export default __webpack_public_path__ + "static/media/fire.ccd7d58c.svg";